// src/index.mjs
import './styles/inject-globals.mjs';
import packageJson from '../package.json';

export * from './components/studio-button/studio-button.mjs';
export * from './components/studio-text/studio-text.mjs';
export * from './components/studio-button-group/studio-button-group.mjs';
export * from './components/studio-input/studio-input.mjs';
export * from './components/studio-badge/studio-badge.mjs';
export * from './components/studio-stepper/studio-stepper.mjs';
export * from './components/studio-loader/studio-loader.mjs';
export * from './components/studio-tooltip/studio-tooltip.mjs';
export * from './components/studio-breadcrumbs/studio-breadcrumbs.mjs';
export * from './components/studio-progress/studio-progress.mjs';
export * from './components/studio-checkbox/studio-checkbox.mjs';
export * from './components/studio-radio/studio-radio.mjs';
export * from './components/studio-toggle/studio-toggle.mjs';
export * from './components/studio-alert/studio-alert.mjs';
export * from './components/studio-popup/studio-popup.mjs';
export * from './components/studio-list/studio-list.mjs';
export * from './components/studio-actions/studio-actions.mjs';
export * from './components/studio-pagination/studio-pagination.mjs';
export * from './components/studio-select/studio-select.mjs';
export * from './components/studio-card/studio-card.mjs';
export * from './components/studio-icon/studio-icon.mjs';
export * from './components/studio-gallery/studio-gallery.mjs';
export * from './components/studio-upload-meta/studio-upload-meta.mjs';
export * from './components/studio-upload/studio-upload.mjs';
export * from './components/studio-tagger/studio-tagger.mjs';

console.log('studio.ui.components.core loaded', packageJson.version);
